module.exports = __webpack_public_path__ + "img/horizontal_2_1_r_3016.0ae890e3.png";